export default "__VITE_ASSET__CNEuOUEJ__"